import { render, staticRenderFns } from "./PermissionManagementDialog.vue?vue&type=template&id=ed8c19da&scoped=true&"
import script from "./PermissionManagementDialog.vue?vue&type=script&lang=js&"
export * from "./PermissionManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./PermissionManagementDialog.vue?vue&type=style&index=0&id=ed8c19da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8c19da",
  null
  
)

export default component.exports